import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for SuiteNavStore, for use in the registry */ export const SuiteNavStoreActionTypes = [
    ActionType.GetSuiteNavSucceededAction,
    ActionType.GetSuiteNavFailedAction
];
